(function () {
    var cardPaymentStates = [
        "Unknown",
        "Pending",
        "Paid Online",
        "Reversed",
        "Declined",
        "Refunding",
    ];

    function cardPaymentStateFilter () {
        return function (input) {
            // If the input is undefined or null, we return undefined|null so that bind once continues to bind until the value is not null.
            if (!input) {
                return input;
            }

            return cardPaymentStates[input];
        };
    }

    angular
        .module('dashboard')
        .filter('cardPaymentState', [ cardPaymentStateFilter ]);
})();
